import gsap from "../../build/node_modules/gsap";
import { ScrollTrigger } from "../../build/node_modules/gsap/ScrollTrigger";
import { CustomEase } from "../_libs/CustomEase.js";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);

window.website = {
  html: document.querySelector("html"),
  body: document.querySelector("body"),
  currentY: 0,
  velocity: 0,
  winW: window.innerWidth,
  winH: window.innerHeight,
  isDesktop: window.innerWidth >= 881 ? true : false,
  isTablet: navigator.userAgent.indexOf("iPad") > -1 || (navigator.userAgent.indexOf("Macintosh") > -1 && "ontouchend" in document) || navigator.userAgent.indexOf("Android") > -1,
  debug: location.hash === "#debug" ? true : false,
  page: null,
};

export default class {
  constructor() {
    this.website = window.website;
  }

  getNameSpace(tgt) {
    return tgt.getAttribute("data-barba-namespace");
  }

  getWinSize() {
    return { w: window.innerWidth, h: window.innerHeight };
  }

  append(t) {
    let target = $(t);
    $(t).remove();
    $("body").append(target);
  }
}

export { gsap };
export { CustomEase };
export { ScrollTrigger };
